import type { DataLayerInfo, PageInfo } from '../../../../shared/types'

export const getCRScamsTopicDataLayer = (pageInfo: PageInfo) => {
  const crTopicDataLayer: DataLayerInfo = {
    ...pageInfo,
    topicName: 'scams',
    content_type: 'topic',
  }

  delete crTopicDataLayer.sub_vertical

  return crTopicDataLayer
}
